import { LOCALES } from 'i18n/locales';

export const ariaSearchIntl = {
    [LOCALES.ENGLISH]: {
        'ariaSearch.placeholder': 'Search',
        'ariaSearch.button': 'Search',
        'ariaSearch.clear': 'Clear search term'
    },
    [LOCALES.WELSH]: {
        'ariaSearch.placeholder': 'Chwiliwch',
        'ariaSearch.button': 'Chwiliwch',
        'ariaSearch.clear': 'Clirio\'r term chwilio'
    }
};
